import { isMostPopularTitle } from "@modules/slides-library/shared/utils/most-popular";
import type { TSlidesFolder } from "@/shared/types";

// True when the active folder is the curated "Most popular" folder — the
// curation view then lists all isPopular slides for the org rather than the
// folder's own folderId-scoped contents.
export const isPopularFolder = (
  folders: TSlidesFolder[] | undefined,
  folderId: string | undefined,
): boolean =>
  !!folderId &&
  !!folders?.some((f) => f._id === folderId && isMostPopularTitle(f.title));
